<template>
  <div>
    <div class="loading" v-show="!showCarousel">Loading....</div>
    <transition name="fade" mode="out-in">
    <div class="photo-carousel" v-images-loaded="imagesHaveLoaded" v-show="showCarousel">
      <div class="photo-cell" v-for="photo in photos" :key="photo" :data-url="'/imgfly/' + photo + '?w=1000'">
        <a href="#" class="photo-cell-image" @click.prevent="openLightbox('/imgfly/' + photo + '?w=1000')">
          <img :src="'/imgfly/' + photo + '?h=718'"/>
        </a>
      </div>
    </div>
    </transition>
    <Lightbox id="mylightbox"
              ref="lightbox"
              :images="images"
              :timeoutDuration="10000"
    ></Lightbox>
  </div>
</template>

<script>
  var Flickity = require('flickity');
  require('flickity-imagesloaded');

  import imagesLoaded from 'vue-images-loaded';
import Lightbox from 'vue-my-photos';

  export default {
    components: {
      Lightbox
    },
    directives: {
      imagesLoaded
    },
    name: 'PhotoGallery',
    props: {
      photos: {
        type: Array,
        required: true
      }
    },
    data : function() {
      return {
        lightbox : null,
        images : [],
        showCarousel : false,
      }
    },
    mounted() {
      //lightbox images
      this.photos.forEach((photo)=> {
        this.images.push({'name':'/imgfly/' + photo + '?w=1000', 'alt':'' })
      });
    },
    methods: {
      initialiseFlickity() {
        this.$nextTick()
          .then(() => {
            let options = { "wrapAround": true, "pageDots": false, imagesLoaded: true, fullscreen: true };
            const route = this.$route.fullPath;
            if(localStorage.getItem(route)) {
              options.initialIndex = parseInt(localStorage.getItem(route));
            }
            this.flkty = new Flickity( '.photo-carousel', options);
            const photoImgs = document.getElementsByClassName("photo-cell-image");
            let width = 0;
            for(var i = 0; i < photoImgs.length; i++) {
              width += photoImgs[i].offsetWidth;
            }
            if(width < window.innerWidth) {
              this.flkty.destroy();
              options.wrapAround = false;
              options.initialIndex = 1;
              this.flkty = new Flickity( '.photo-carousel', options);
            }
            this.flkty.on( 'staticClick', ( event, pointer, cellElement, cellIndex ) => {
              // show lightbox
              this.$refs.lightbox.show(cellElement.dataset.url);
            });
            this.flkty.on( 'change', ( index ) => {
              localStorage.setItem(route, index);
            });
          });
      },
      openLightbox(name) {
          //$event.preventDefault();
        if(window.innerWidth <= 640) {
          this.$refs.lightbox.show(name);
        }
      },
      imagesHaveLoaded() {

        this.showCarousel = true;
        if(window.innerWidth > 640) {
          this.initialiseFlickity();
        }
      }
    }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// resources/js/components/PhotoGallery.vue